import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { isPublishingInitialState } from "./initialState";

const publishingReducer = (
  state: State.PublishingStatus = isPublishingInitialState,
  action: PdApiActions
): State.PublishingStatus => {
  switch (action.type) {
    case PdApiActionsEnum.SET_PUBLISHING_LOCALIZATIONS: {
      const publishing = action.payload;
      return { ...state, isPublishingLocalizations: publishing };
    }
    case PdApiActionsEnum.LOCALIZATION_PUBLISH_SUCCEEDED: {
      const completedAt = action.payload;
      return { ...state, lastLocalizationPublishCompletedAt: completedAt };
    }
    default:
      return state;
  }
};

export default publishingReducer;
